var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPredictiveDockDoor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M16.6 24.6H6.5c-.5 0-1-.4-1-1v-1.5h1v1.5h10v-1.5h1v1.5c0 .6-.4 1-.9 1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M22 4.8h-1V2.4H2.2v2.4h-1V1.4H22z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M18.9 7.5h1v6.8h-1zM17.5 22.7H3.3V7.5h1v14.2h13.2zM1 5.6h21v1H1zM1.2 7.5h1v15.3h-1zM21 20.8h1v2h-1zM21 7.5h1v4.6h-1z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "m18.5 21.7-.1-.5c-.3-1.4-1.6-2-2.2-2.3-.2-.1-.4-.3-.4-.6s.2-.5.4-.6c.4-.1 1.7-.6 2-2.2l.1-.4h.5c.3 0 .5.2.5.5.1.7.7 1.8 2.2 2.2l.4.1.1.5c0 .3-.2.5-.4.5-1.9.4-2.1 2.2-2.1 2.2v.4zm-1.2000000000000002-3.2c.5.3 1.1.7 1.5 1.3.3-.5.7-1 1.3-1.4-.6-.4-1.1-.9-1.4-1.4-.3.8-.9 1.2-1.4 1.5M22.4 16.7l-.1-.5c-.1-.8-1-1.2-1.3-1.3l-.3-.1v-.4c0-.2.2-.5.4-.5.2-.1 1-.3 1.2-1.3l.1-.4h.8l.1.4s.2 1 1.3 1.3l.4.1v.8l-.4.1c-1.1.2-1.2 1.3-1.2 1.3v.4zm-.3-2.3q.3.15.6.6c.1-.2.3-.4.5-.6l-.6-.6c-.1.3-.3.5-.5.6m2.2-.5"
})));
export default SvgPredictiveDockDoor;